import { render, staticRenderFns } from "./platformGoods.vue?vue&type=template&id=636e5ee5&scoped=true&"
import script from "./platformGoods.vue?vue&type=script&lang=js&"
export * from "./platformGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636e5ee5",
  null
  
)

export default component.exports